import { createSlice } from '@reduxjs/toolkit'
import { logout, setProduct } from './authSlice';

interface IPayments {
  charges: number;
  employerCode: string;
  paymentItems: Array<any>;
  period: string;
  scheduleId: string;
  totalAmount: number;
  totalEmployee: number;
  totalPfa: number;
  transactionDate: string;
}

interface DashboardState {
  payments: Array<IPayments>,
  pendingPayments: Array<IPayments> | [],
  notifications: Array<any> | [],
  uploadHistory: Array<any> | null,
  uploadReferenceSummary: {
    reference: string;
    data: Array<any>;
  } | null,
  summaryBeneficiaries: {
    scheduleId: string;
    items: Array<any>;
  } | null
}

const initialState: DashboardState = {
  payments: [],
  pendingPayments: [],
  notifications: [],
  uploadHistory: null,
  uploadReferenceSummary: null,
  summaryBeneficiaries: null
}

export const paymentsSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    addPaymentHistory: (state, action) => {
      state.payments = action.payload;
    },
    addPendingPayment: (state, action) => {
      state.pendingPayments = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setUploadHistory: (state, action) => {
      state.uploadHistory = action.payload;
    },
    clearUploadHistory: (state) => {
      state.uploadHistory = [];
    },
    setUploadReferenceSummary: (state, action) => {
      state.uploadReferenceSummary = action.payload;
    },
    clearUploadReferenceSummary: (state) => {
      state.uploadReferenceSummary = null;
    },
    setSummaryBeneficiaries: (state, action) => {
      state.summaryBeneficiaries = action.payload;
    },
    clearSummaryBeneficiaries: (state) => {
      state.summaryBeneficiaries = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state = {...initialState};
      return state;
    })
    builder.addCase(setProduct, (state) => {
      state = {...initialState};
      return state;
    });
  }
})

export const {
  addPaymentHistory,
  addPendingPayment,
  setNotifications,
  setUploadHistory,
  clearUploadHistory,
  setUploadReferenceSummary,
  clearUploadReferenceSummary,
  setSummaryBeneficiaries,
  clearSummaryBeneficiaries
} = paymentsSlice.actions;

export default paymentsSlice.reducer;
